(function() {
    'use strict';
    angular
        .module('sigmasfApp')
        .factory('TempCustomer', TempCustomer);

    TempCustomer.$inject = ['$resource', 'DateUtils'];

    function TempCustomer ($resource, DateUtils) {
        var resourceUrl =  'api/temp-customers/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.issuedDate = DateUtils.convertDateTimeFromServer(data.issuedDate);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
